export default __webpack_public_path__ + "static/media/KheshattaValleyMap.25e4a58a.jpg";